import { useEffect } from 'react';
import { setSeo, resetSeo } from '@/lib/seo';

/**
 * Drop-in component that marks the current route as non-indexable
 * (e.g. authenticated dashboards, wizards). Renders nothing.
 */
export function NoindexSeo() {
  useEffect(() => {
    setSeo({ robots: 'noindex, nofollow' });
    return () => resetSeo();
  }, []);
  return null;
}
